module.exports = __webpack_public_path__ + "img/tz3670_center_003.3fa21675.png";